import { ArticleShell } from './ArticleShell';

export function Boundaries() {
    return (
        <ArticleShell>
            <h1 className="mb-10 text-mobile-display-2">
                Hvorfor er grænsesætning vigtigt?
            </h1>

            <p className="mb-20 text-body-headline text-dark-red">
                Har du nogensinde følt, at du siger "ja" til ting, du egentlig
                ikke har lyst til? Eller at du altid prioriterer andres behov
                over dine egne? Det er helt normalt!
            </p>

            <p className="mb-20 text-body">
                Mange af os er glade for at imødekomme andre og vil gerne have,
                at folk omkring os har det godt. Det er en god menneskelig
                egenskab. Denne genskab kan dog også godt tage overhånd, således
                at vi kan glemme vores egne behov.
            </p>

            <p className="mb-20 text-body">
                At sætte grænser handler om at værne om vores egne behov, og
                ikke om at være hård, egoistisk eller stædig. Grænsesætning kan
                være et vigtigt greb i at beskytte dit mentale helbred og
                trivsel. Hvis du ofte overskrider dine egne grænser, kan det
                føre til stress og følelsen af at miste kontrollen over dit liv.
                Det er vigtigt både for at passe på dig selv – og faktisk også
                for at dine relationer kan fungere godt. Grænsesætning hjælper
                altså ikke kun dig, men også dine relationer for at få en
                fornemmelse af hvordan du har det.
            </p>

            <h2 className="mb-20 text-mobile-display-1">
                Hvorfor er grænser så vigtige?
            </h2>

            <p className="mb-20 text-body">
                For mange er manglende grænsesætning en kilde til stress,
                mistrivsel og overtænkning. For hvis du hele tiden ignorerer og
                nedprioriterer dine egne behov til fordel for andres, kan det
                forstærke følelser af utilstrækkelighed. Det kan endda føles som
                om, du mister "fornemmelsen for dig selv" – hvem du er, og hvad
                du egentlig har brug for.
            </p>

            <h2 className="mb-10 text-mobile-display-1">
                Hvordan ved du, om dine grænser er nået?
            </h2>

            <p className="mb-10 text-body-headline text-dark-red">
                Grænser er lidt ligesom tæer. Vi mærker dem typisk først, når vi
                bliver trådt over dem!
            </p>

            <p className="mb-20 text-body">
                Hvis du har en idé om, at du skal blive bedre til at sætte
                grænser, så prøv at tænke over: Hvilke situationer har du
                egentlig oplevet, hvor du kunne mærke, at en grænse blev
                overskredet? Måske var det en ven, der altid lånte penge og
                aldrig betalte tilbage, eller en aftale med en ven, som du sagde
                ja til, selvom du egentlig kunne mærke at du ikke havde tid og
                overskud til det.
            </p>

            <div className="rounded-[10px] bg-dark-red-10p p-20">
                <h2 className="mb-20 text-mobile-display-1">
                    To gode greb til at blive bedre til at sætte grænser
                </h2>

                <p className="mb-10 text-body-headline text-dark-red">
                    Selvrefleksion
                </p>

                <p className="mb-20 text-body">
                    Brug tid på at finde ud af, hvad der er vigtigt for dig.
                    Hvad er dine værdier? Hvad har du brug for? Hvad er dine
                    prioriteter? Når du forstår dig selv bedre, får du et solidt
                    grundlag for at vide, hvornår du skal sige fra, og hvordan
                    du kan formidle dine grænser på en god måde.
                </p>

                <p className="mb-10 text-body-headline text-dark-red">
                    Prioriter dine relationer
                </p>

                <p className="text-body">
                    Vælg at bruge din energi på relationer, hvor dine grænser
                    bliver respekteret og værdsat. Det skaber en gensidig
                    respektfuld dynamik og hjælper dig med at vokse som person.
                    Det betyder ikke, at du skal droppe alle, der udfordrer dig,
                    men at du skal være opmærksom på, hvem der løfter dig op, og
                    hvem der dræner dig.
                </p>
            </div>

            <h2 className="my-20 text-mobile-display-1">
                Kan man sætte for mange grænser?
            </h2>

            <p className="mb-20 text-body">
                Ja, det kan man faktisk godt! Som med alt andet kan et
                overdrevent fokus på grænser føre til, at det bliver for meget.
                Hvis vi konstant er optaget af vores egne grænser og behov, kan
                vi risikere at miste blikket for andre menneskers behov. Det
                handler om at finde en balance, hvor du passer på dig selv, men
                stadig er åben og hensynsfuld over for andre.
            </p>

            <p className="mb-20 text-body">
                Et godt skridt på vejen til at sætte grænser, der giver en god
                effekt i dit liv, er at blive klar over, hvad der faktisk er
                vigtigt for dig. I modul 4 vil vi kigge nærmere på dine værdier
                og forsøge at indkredse et kompas, der kan gøre det tydeligt for
                dig, hvornår noget er vigtigt for dig eller ej. Det vil hjælpe
                dig med at navigere i hverdagen og sætte grænser, der føles
                rigtige for dig.
            </p>
        </ArticleShell>
    );
}
